import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AppleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"apple"}/>
}
